import { useState, useEffect } from 'react';

function calcTimeLeft(target) {
  if (!target) return null;
  const diff = new Date(target) - new Date();
  if (diff <= 0) return { expired: true };
  return {
    jours:    Math.floor(diff / 86400000),
    heures:   Math.floor((diff % 86400000) / 3600000),
    minutes:  Math.floor((diff % 3600000) / 60000),
    secondes: Math.floor((diff % 60000) / 1000),
  };
}

export function useCountdown(target) {
  const [tl, setTl] = useState(() => calcTimeLeft(target));
  useEffect(() => {
    const t = setInterval(() => setTl(calcTimeLeft(target)), 1000);
    return () => clearInterval(t);
  }, [target]);
  return tl;
}
